import { render, staticRenderFns } from "./ReturnInfo.vue?vue&type=template&id=6448a61e&scoped=true&"
import script from "./ReturnInfo.vue?vue&type=script&lang=js&"
export * from "./ReturnInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReturnInfo.vue?vue&type=style&index=0&id=6448a61e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6448a61e",
  null
  
)

export default component.exports